<template>
  <div :class="`m-portal m-portal-${routeType}-page`">
    <portal-arti-page-dest v-if="dest"></portal-arti-page-dest>
    <portal-arti-page-picture v-if="picture"></portal-arti-page-picture>
    <portal-arti-page-picture5 v-if="picture5"></portal-arti-page-picture5>
    <div v-if="nopicture">
      <portal-nav-top></portal-nav-top>
      <div id="ljh-culture">
        <div class="container-fluid" style="width:1100px;">
          <el-row :gutter="20">
            <el-col :span="6" class="left-menu-wrap">
              <portal-cult-nav></portal-cult-nav>
            </el-col>
            <el-col :span="18" class="content-page-wrap">
              <div class="content-page">
                <div class="navigation">
                  <span>首页</span>
                  <span>&nbsp;>&nbsp;</span>
                  <span>文化概述</span>
                  <span>&nbsp;>&nbsp;</span>
                  <span>朱子年谱</span>
                </div>
                <div class="chronicles container-fluid">
                  <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="朱子生平" name="first">
                      <div v-show="indication1">
                        <h3 style="text-align: center;">朱子生平</h3>
                        <img
                          id="zzys"
                          src="../../assets/portal/sp.png"
                          border="0"
                          style="margin: auto;"
                          usemap="#planetmap"
                          alt="Planets"
                        />
                        <map name="planetmap" id="planetmap">
                          <area
                            shape="rect"
                            coords="295, 125, 425, 20"
                            alt="Venus"
                            class="qtip2"
                            title="九月十五日，出生于福建尤溪，父溪朱松，母祝氏。"
                          />
                          <area
                            shape="rect"
                            coords="500, 125, 595, 20"
                            alt="Venus"
                            class="qtip2"
                            title="朱松迁居政和星溪庐墓守丧，随父就读于云根书院和星溪书院。"
                          />
                          <area
                            shape="rect"
                            coords="115, 320, 225, 195"
                            alt="Venus"
                            class="qtip2"
                            title="娶刘勉之长女刘清四。春，赴临安应试，中王佐榜第五甲第九十名进士。"
                          />
                          <area
                            shape="rect"
                            coords="310, 320, 415, 195"
                            alt="Venus"
                            class="qtip2"
                            title="三月，父病故，临终前让朱熹学于五夫的刘子犟、刘勉之、胡宪三先生，并把家事托给在崇安五夫里奉祠家居的刘子羽。遂同母、妹迁居崇安五夫。"
                          />
                          <area
                            shape="rect"
                            coords="485, 320, 595, 195"
                            alt="Venus"
                            class="qtip2"
                            title="六月，朱松赴行在临安赴临安前，送朱熹母子寄居浦城。"
                          />
                          <area
                            shape="rect"
                            coords="105, 455, 235, 345"
                            alt="Venus"
                            class="qtip2"
                            title="回祖籍婺源省祖墓。"
                          />
                          <area
                            shape="rect"
                            coords="300, 455, 410, 345"
                            alt="Venus"
                            class="qtip2"
                            title="任同安主薄兼管县学，次子朱埜出生。"
                          />
                          <area
                            shape="rect"
                            coords="485, 455, 585, 345"
                            alt="Venus"
                            class="qtip2"
                            title="春正月，徒步百里往延平拜见李侗，至三月才归。十二月，差监漳州南岳庙。"
                          />
                          <area
                            shape="rect"
                            coords="115, 630, 215, 520"
                            alt="Venus"
                            class="qtip2"
                            title="五月，在崇安开耀乡创建五夫里社仓三间。九月，定《〈资治通鉴纲目〉凡例》。十一月，朝廷召赴行在，以禄不及养辞，《知言疑义》成。"
                          />
                          <area
                            shape="rect"
                            coords="300, 630, 410, 520"
                            alt="Venus"
                            class="qtip2"
                            title="葬母于建阳马伏的寒泉坞，开始了六年寒泉著述时期。七月，迁父墓于寂历山。十二月，沼赴行在，以居丧辞。"
                          />
                          <area
                            shape="rect"
                            coords="480, 630, 590, 520"
                            alt="Venus"
                            class="qtip2"
                            title="八月，赴潭州访张栻，会讲岳麓。十一月，与张栻及门人同游衡山，互相吟咏之作结集为《南岳唱酬集》。十二月，归崇安，除枢密院编修官，待次。"
                          />
                          <area
                            shape="rect"
                            coords="115, 780, 215, 685"
                            alt="Venus"
                            class="qtip2"
                            title="四月，吕祖谦自浙江东阳来五夫与朱熹相会，后，至寒泉精舍共编《近思录》。五月与吕祖谦同赴江西信州，会陆九渊兄弟于鹅湖寺。七月，云谷的晦庵草堂落成，为之作《云谷记》。五女朱未出生。"
                          />
                          <area
                            shape="rect"
                            coords="300, 780, 410, 685"
                            alt="Venus"
                            class="qtip2"
                            title="屡辞知南康军不允，三月到南康任。立周濂溪祠于学宫，以二程先生配。又立五贤祠。十月，重建“白鹿洞书院”。"
                          />
                          <area
                            shape="rect"
                            coords="480, 780, 590, 685"
                            alt="Venus"
                            class="qtip2"
                            title="正月，巡历浙东路诸郡，奏劾劣吏，陈亮来访。六月，刻四书于婺州。七月，巡台州，奏劾前知州唐仲友贪污不法。八月，除直徽猷阁，辞，不允。差江西提点刑狱，辞。九月去任归崇安。十一月，始受直微猷阁职名，仍辞江西提点刑狱职，并请祠。"
                          />
                          <area
                            shape="rect"
                            coords="115, 970, 225, 840"
                            alt="Venus"
                            class="qtip2"
                            title="六月，建阳考亭新居成。十二月，除知静江府广南西路经略安抚使，辞。《孟子要略》成。"
                          />
                          <area
                            shape="rect"
                            coords="300, 970, 410, 840"
                            alt="Venus"
                            class="qtip2"
                            title="四月，抵漳州任。六月，奏行经界法。十月，以经界不行及境内地震足疾不能赴锡宴上自劾状，乞予罢黜奉祠，不允。同月，刊刻《四子》(《四书》)于漳州。"
                          />
                          <area
                            shape="rect"
                            coords="480, 970, 590, 840"
                            alt="Venus"
                            class="qtip2"
                            title="正月，差主管台州崇道观。二月，拜命。四月，武夷精舍成。"
                          />
                          <area
                            shape="rect"
                            coords="115, 1135, 225, 1005"
                            alt="Venus"
                            class="qtip2"
                            title="正月，考亭陈氏修建聚星亭，为其设计聚星亭画屏，作《聚星亭画像赞》。三月 八日，手书黄榦告诀，以道相托，收拾《礼书》文字。初九午时卒于考亭。十一月葬于建阳县唐石里之大林谷。"
                          />
                          <area
                            shape="rect"
                            coords="290, 1135, 380, 1005"
                            alt="Venus"
                            @click="change1()"
                          />
                        </map>
                      </div>
                      <div v-show="indication2">
                        <a style="text-align: center;display:block;cursor: pointer;" @click="change2()"><img style="width:64px;height:25px;" src="../../assets/portal/fanhui.png"></a><br>
                      <bs-page :filter="filter" :meta="meta" ref="refId" id="zzsp" content-class>
                        <template slot="data" slot-scope="slot">
                          <div v-for="item in slot.data" :key="item.resumeId">
                            <el-row
                              :gutter="0"
                              class="chronicle"
                              style="line-height:21px;letter-spacing:2px;"
                            >
                              <el-col :span="7" class="time">
                                <span v-text="item.dynasty"></span>
                                <span>{{item.year}}年</span>
                                <span>{{item.age}}岁</span>
                              </el-col>
                              <el-col :span="2">
                                <div class="timeline">
                                  <div class="line"></div>
                                  <div class="dot"></div>
                                </div>
                              </el-col>
                              <el-col :span="15" class="description">
                                <p style="margin-top: 0;" v-text="item.remark"></p>
                              </el-col>
                            </el-row>
                          </div>
                          <el-row :gutter="0" class="chronicle">
                            <el-col :span="7" class="time">&nbsp;&nbsp;&nbsp;</el-col>
                            <el-col :span="2">
                              <div class="timeline">
                                <div class="dot"></div>
                              </div>
                            </el-col>
                            <el-col :span="15" class="description">&nbsp;&nbsp;&nbsp;</el-col>
                          </el-row>
                        </template>
                        <template slot="empty">空数据</template>
                      </bs-page>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="朱子历朝褒封表" name="third">
                      <content style="line-height: 21px; letter-spacing: 2px;">
                        <h3 id="zzlc" style="text-align: center;">朱子历朝褒封表</h3>
                        <p>乾隆四十三年奉敕修纂的《钦定国子监志》中，列“先贤朱子”条目：</p>
                        <p>宋淳祐元年从祀；元至正二十二年封齐国公；明崇祯十五年称为先贤，位在七十子之下，汉唐诸儒之上；国朝康熙五十一年升为十一哲。</p>
                        <p>孔庙尊奉的是大成至圣的孔子。孔子塑像的东西侧是“四配”，“四配”是从祀的最高等级。接着是从祀第二等级的“十哲”。十哲之下，依次是“先贤”、“先儒”。</p>
                        <p>四配是孔子的四大弟子，颜渊﹑子思居东，曾参﹑孟轲居西。十哲是孔子优秀的十位学生：次东西向的是闵损、冉雍、端木赐、仲由、卜商；次西东向的是冉耕、宰予、冉求、言偃、颛孙师。先贤是孔庙中从祀的第三个等级，大多数为孔子的弟子，周敦颐、二程等大儒也位列其中，共79人。先儒是孔庙中从祀的第四等级，为历代知名儒者，共77人，如杨时、李侗等。</p>
                        <p>宋淳祐元年（1241），诏朱子从祀孔庙，入孔庙的先儒行列。明崇祯十五年（1642），诏称朱子为“先贤”，地位列于汉唐诸儒之上。清康熙五十一年（1712），朱子在孔庙从祀诸儒中的位置，从“先贤”提到“十哲”之次，位在卜商之后，次东西向。非孔门弟子而入“十哲”之次的，仅朱子一人，也由此，“十哲”变成“十一哲”。清乾隆三年（1738），升孔子弟子有若为十二哲，位在卜商之下，移朱子位于西面。至此，孔庙内“四配十二哲”的规制确立。</p>
                        <p>统治者对朱子进行褒封的同时，朱子的理论学说也上升至官方意识形态的层面，据《元史·选举志》《明史·选举志》《清史稿·选举志》记载，朱子的《四书集注》、《周易本义》《诗集传》为元、明、清三代科举考试的必读教材和出题蓝本，三个朝代的《选举志》在“《四书》主朱子《集注》，《易》主程《传》、朱子《本义》……《诗》主朱子《集传》”这句话上，基本一致。科举必读的“四书五经”九部经典中，朱子占六部。</p>
                        <p>清朱玉编的《朱子文集大全类编》&nbsp;第一册卷三专列《历朝褒典》一节；兰宗荣先生的《朱子的旅游世界——朱熹旅游文化与文化旅游研究》一书，也专列《历代皇帝对朱子的褒封与祀典》一节。现综合科举制度史等相关内容，将朱子历朝褒封情况整理如下：</p>
                        <table
                          style="border-collapse: collapse; border-color: #000000;width:100%; margin-left: auto; margin-right: auto;"
                          border="1"
                        >
                          <tbody>
                            <tr>
                              <td width="34">
                                <p>
                                  <strong>朝代</strong>
                                </p>
                              </td>
                              <td width="54">
                                <p>
                                  <strong>年号</strong>
                                </p>
                              </td>
                              <td width="53">
                                <p>
                                  <strong>公元纪年</strong>
                                </p>
                              </td>
                              <td width="409">
                                <p>
                                  <strong>褒封情况</strong>
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td rowspan="14" width="34">
                                <p>
                                  <strong>宋</strong>
                                </p>
                              </td>
                              <td width="54">
                                <p>宁宗嘉泰二年</p>
                              </td>
                              <td width="53">
                                <p>1202</p>
                              </td>
                              <td width="409">
                                <p>诏朱子华文阁待制与致仕恩泽。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>宁宗嘉定元年</p>
                              </td>
                              <td width="53">
                                <p>1208</p>
                              </td>
                              <td width="409">
                                <p>诏赐朱子遗表恩泽，赐谥曰“文”，世人尊称文公。与“元公”周敦颐、“纯公”程颢、“正公”程颐、“明公”张载、“宣公”张栻并列。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>嘉定三年</p>
                              </td>
                              <td width="53">
                                <p>1210</p>
                              </td>
                              <td width="409">
                                <p>追赠朱子为中散大夫，宝谟阁直学士，以明堂恩加通议大夫。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>嘉定五年</p>
                              </td>
                              <td width="53">
                                <p>1212</p>
                              </td>
                              <td width="409">
                                <p>宁宗听从国子司业刘爚的建议，以朱子所撰《四书集注》、《白鹿洞书院学规》颁于太学，作为教科书。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>理宗宝庆三年</p>
                              </td>
                              <td width="53">
                                <p>1227</p>
                              </td>
                              <td width="409">
                                <p>宋理宗认为《四书集注》“发挥圣贤之蕴，羽翼斯文，有补治道”，&nbsp;诏赠朱子太师，追封信国公。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>理宗绍定三年</p>
                              </td>
                              <td width="53">
                                <p>1230</p>
                              </td>
                              <td width="409">
                                <p>改封朱子徽国公。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>理宗嘉熙元年</p>
                              </td>
                              <td width="53">
                                <p>1237</p>
                              </td>
                              <td width="409">
                                <p>尤溪知县李修在朱子诞生地创建朱子祠，奉祀朱子父子。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>理宗嘉熙二年</p>
                              </td>
                              <td width="53">
                                <p>1238</p>
                              </td>
                              <td width="409">
                                <p>赐御书“建安书院”额。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>理宗淳祐元年</p>
                              </td>
                              <td width="53">
                                <p>1241</p>
                              </td>
                              <td width="409">
                                <p>诏恩从祀孔庙。加诏周敦颐、张载、程颐、程颢封爵，并祀孔庙。朱子取得与北宋四子并列的地位。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>理宗淳祐四年</p>
                              </td>
                              <td width="53">
                                <p>1244</p>
                              </td>
                              <td width="409">
                                <p>诏改沧州精舍为考亭书院，并赐御书额。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>理宗淳祐六年</p>
                              </td>
                              <td width="53">
                                <p>1246</p>
                              </td>
                              <td width="409">
                                <p>赐徽州“紫阳书院”御书额。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>理宗宝祐元年</p>
                              </td>
                              <td width="53">
                                <p>1253</p>
                              </td>
                              <td width="409">
                                <p>赐尤溪“南溪书院”御书额。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>度宗咸淳元年</p>
                              </td>
                              <td width="53">
                                <p>1265</p>
                              </td>
                              <td width="409">
                                <p>朝命宰执访朱子后人贤能者录用。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>度宗咸淳五年</p>
                              </td>
                              <td width="53">
                                <p>1269</p>
                              </td>
                              <td width="409">
                                <p>诏赐婺源朱氏故居名“文公阙里”。</p>
                              </td>
                            </tr>
                            <tr>
                              <td rowspan="4" width="34">
                                <p>
                                  <strong>元</strong>
                                </p>
                              </td>
                              <td width="54">
                                <p>仁宗皇庆二年</p>
                              </td>
                              <td width="53">
                                <p>1313</p>
                              </td>
                              <td width="409">
                                <p>恢复科举，诏定以朱子《四书集注》为标准取士，朱学定为科场程式。《元史•选举志•科目》载：《大学》《论语》《孟子》《中庸》，用朱氏章句集注，《诗》以朱氏为主，《周易》以程氏、朱氏为主。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>惠帝至元元年</p>
                              </td>
                              <td width="53">
                                <p>1335</p>
                              </td>
                              <td width="409">
                                <p>奉旨婺源创徽国文公庙。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>惠帝至元二年</p>
                              </td>
                              <td width="53">
                                <p>1136</p>
                              </td>
                              <td width="409">
                                <p>朱子五世孙朱勋奉朝廷指派，携带次子朱域、三子朱境回祖居婺源掌管家庙祀事。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>惠宗至正二十二年</p>
                              </td>
                              <td width="53">
                                <p>1362</p>
                              </td>
                              <td width="409">
                                <p>追谥朱松“献靖公”，改封朱子齐国公。制词有云：“圣贤之藴，载诸经义。”</p>
                              </td>
                            </tr>
                            <tr>
                              <td rowspan="11" width="34">
                                <p>
                                  <strong>明</strong>
                                </p>
                              </td>
                              <td width="54">
                                <p>洪武二年</p>
                              </td>
                              <td width="53">
                                <p>1369</p>
                              </td>
                              <td width="409">
                                <p>朱元璋下诏：&nbsp;国家明经取士，&nbsp;说经者以宋儒传著为主，&nbsp;行文者以典实纯正为主。追封朱子为徽国公。《明史•选举二》记载：《四书》主朱子集注，《易》主程《传》、朱子《本义》，&nbsp;《诗》主朱子《集传》。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>永乐十五年</p>
                              </td>
                              <td width="53">
                                <p>1417</p>
                              </td>
                              <td width="409">
                                <p>四月，颁《五经四书》《性理大全》于两京六部、国子监及天下府、州、县学。谕礼部曰：“此书，学者之根本。圣贤精蕴，悉具于是。其以朕意晓天下学者，令尽心讲明，无徒视为具文也。”朱子的思想成为学校根本和取士之制。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>景泰六年</p>
                              </td>
                              <td width="53">
                                <p>1455</p>
                              </td>
                              <td width="409">
                                <p>诏建安九世嫡长孙朱梴袭翰林院五经博士，婺源守祠九世孙朱楙送国子监读书。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>景泰七年</p>
                              </td>
                              <td width="53">
                                <p>1456</p>
                              </td>
                              <td width="409">
                                <p>旨令修祠堂春秋猪羊祭祀，钦降建安祠祭祝文。八世孙朱泗奏乞朱子门人黄榦、蔡沈、刘爚、真德秀配祀，从之。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>成化十八年</p>
                              </td>
                              <td width="53">
                                <p>1482</p>
                              </td>
                              <td width="409">
                                <p>题准歙县的紫阳书院有司致祭，“有司岁严祀事，而以蔡元定、黄勉斋配食”。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>弘治四年</p>
                              </td>
                              <td width="53">
                                <p>1491</p>
                              </td>
                              <td width="409">
                                <p>尤溪县国子监生林海奏准每年九月十五日文公诞辰于南溪书院特祭。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>弘治十五年</p>
                              </td>
                              <td width="53">
                                <p>1502</p>
                              </td>
                              <td width="409">
                                <p>题准婺源县修祠致祭。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>正德二年</p>
                              </td>
                              <td width="53">
                                <p>1507</p>
                              </td>
                              <td width="409">
                                <p>题准台州府建祠致祭。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>嘉靖二年</p>
                              </td>
                              <td width="53">
                                <p>1523</p>
                              </td>
                              <td width="409">
                                <p>诏命婺源朱子之十一世孙朱墅为翰林院五经博士，奉祀。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>嘉靖九年</p>
                              </td>
                              <td width="53">
                                <p>1530</p>
                              </td>
                              <td width="409">
                                <p>诏以献靖公（朱松）从祀启圣祠，会天下学宫一体并祀，通称先儒朱氏。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>崇祯十五年</p>
                              </td>
                              <td width="53">
                                <p>1642</p>
                              </td>
                              <td width="409">
                                <p>诏先儒朱子改称“先贤”，位在汉唐诸儒之上。</p>
                              </td>
                            </tr>
                            <tr>
                              <td rowspan="6" width="34">
                                <p>
                                  <strong>清</strong>
                                </p>
                              </td>
                              <td width="54">
                                <p>康熙二十五年</p>
                              </td>
                              <td width="53">
                                <p>1686</p>
                              </td>
                              <td width="409">
                                <p>御书“学达性天”匾颁武夷精舍。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>康熙二十九年</p>
                              </td>
                              <td width="53">
                                <p>1690</p>
                              </td>
                              <td width="409">
                                <p>命先贤朱子十八世孙朱潆承袭五经博士以主持福建祭祀。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>康熙四十四年</p>
                              </td>
                              <td width="53">
                                <p>1705</p>
                              </td>
                              <td width="409">
                                <p>为建阳朱子祠题御匾并对联，御匾为“大儒世泽”，对联为“诚意正心阐邹鲁之实学，主敬穷理绍廉洛之真传”。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>康熙五十一年</p>
                              </td>
                              <td width="53">
                                <p>1712</p>
                              </td>
                              <td width="409">
                                <p>诏朱子从孔庙的配祀诸儒中，升至大成殿配享，位于十哲之次。御敕李光地等编《朱子全书》、《性理精义》，并御笔为序，在序中称朱子“集大成而绪千百年绝传之学，开愚蒙而立亿万世一定之规”。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>康熙五十五年</p>
                              </td>
                              <td width="53">
                                <p>1716</p>
                              </td>
                              <td width="409">
                                <p>御书“文山毓哲”额悬于尤溪南溪书院。</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="54">
                                <p>乾隆三年</p>
                              </td>
                              <td width="53">
                                <p>1738</p>
                              </td>
                              <td width="409">
                                <p>升孔子弟子有若为十二哲，位在卜商之下，移朱子位于西面。</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </content>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <portal-footer></portal-footer>
    </div>
    <!-- <el-backtop target=".page-component__scroll .el-scrollbar__wrap"></el-backtop> -->
  </div>
</template>
<script>
//import jQuery from "jquery";
//import qtip2 from "qtip2";

require("../../styles/portal/culture.scss");

export default {
  data() {
    return {
      indication1: true,
      indication2: false,
      activeName: "first",
      visible: false,
      routeType: "arti",
      picture: false,
      picture5: false,
      dest: false,
      nopicture: true,
      meta: {
        module: this.$route.params._module,
        field: this.$route.params._field
      },
      filter: {
        pageIndex: 1,
        pageSize: 200
      },
      api: null
    };
  },
  mounted() {
    let jQuery = require("jquery");
    let qtip2 = require("qtip2");
    setTimeout(() => {
      jQuery(".qtip2").qtip({
        content: jQuery(this).attr("title"),
        position: {
          my: "top left",
          target: "mouse"
        },
        style: {
          classes: "myCustomClass",
          width: 150
        }
      });
    }, 500);
  },
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BsPage: () => import("../../components/bs-page"),
    PortalNavTop: () => import("./portal-nav-top"),
    PortalNavLeft: () => import("./portal-nav-left"),
    PortalArtiPagePicture5: () => import("./portal-arti-page-picture5"),
    PortalArtiPageDest: () => import("./portal-arti-page-dest"),
    PortalArtiPagePicture: () => import("./portal-arti-page-picture"),
    PortalCultNav: () => import("./portal-cult-nav"),
    PortalFooter: () => import("./portal-footer")
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleDetail(item) {
      let _module = this.$route.params._module;
      let _field = this.$route.params._field;
      this.$router.push({
        path: `/portal/arti/detail/${_module}/${_field}_detail/${item.artiId}`
      });
    },
    pageSizeChange(val) {
      let that = this;
      that.filter.pageSize = val;
      this.$refs["refId"].loadData();
    },
    pageIndexChange(val) {
      let that = this;
      that.filter.pageIndex = val;
      this.$refs["refId"].loadData();
    },
    change1() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.indication1 = false;
      this.indication2 = true;
    },
    change2() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.indication1 = true;
      this.indication2 = false;
    }
  },
  created() {
    this.$menuFn.setTitle("朱子年谱-朱子文化·综合信息服务平台");
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "portal-cult-page") {
        this.$menuFn.setTitle("朱子年谱-朱子文化·综合信息服务平台");
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "page",
        "portal",
        true
      );
      if (this.routeWatch && contains) {
        this.$refs["refId"].clearData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.$refs["refId"].loadData();
      }
    }
  }
};
</script>
<style lange="sass" scoped>
@import "../../../node_modules/qtip2/dist/jquery.qtip.min.css";
.key {
  background: #e8d9bc;
  color: #520000;
  font-weight: bold;
}
.myCustomClass {
  border-color: rgb(0, 190, 0);
  background-color: #f5e8d3;
}
.qtip2 .in {
  color: red;
  font-weight: bold;
}
.qtip2 .out {
  color: #5a290c;
  font-weight: bold;
}
</style>